import React from 'react';
import { View, Text, Pressable, StyleSheet, Image, Platform } from 'react-native';
import BaseModal, { modalStyles, HoverButton } from './BaseModal';
import { FontAwesome6 } from '@expo/vector-icons';
import MenuListItem from '../ui/MenuListItem';
import ModalStickyFooter from '../ui/ModalStickyFooter';
import { colors, typography } from '../../styles/theme';

interface LandingModalProps {
  visible: boolean;
  onPlay: () => void;
  onHowToPlay: () => void;
  onBrowsePacks: () => void;
  onCreateCustom: () => void;
  onToggleMute: () => void;
  onToggleEasyMode: () => void;
  onWhyPiclo: () => void;
  isMuted: boolean;
  isEasyMode: boolean;
}

export default function LandingModal({
  visible,
  onPlay,
  onHowToPlay,
  onBrowsePacks,
  onCreateCustom,
  onToggleMute,
  onToggleEasyMode,
  onWhyPiclo,
  isMuted,
  isEasyMode
}: LandingModalProps) {
  return (
    <BaseModal
      visible={visible}
      onClose={onPlay}
      footer={(
        <ModalStickyFooter>
          <HoverButton
            style={[modalStyles.primaryButton, styles.footerPrimaryButton]}
            hoverStyle={modalStyles.primaryButtonHover}
            textStyle={modalStyles.primaryButtonText}
            onPress={onPlay}
          >
            Play Daily Puzzle
          </HoverButton>
          <HoverButton
            style={modalStyles.clearButton}
            textStyle={modalStyles.clearButtonText}
            onPress={onHowToPlay}
          >
            How to Play
          </HoverButton>
        </ModalStickyFooter>
      )}
    >


      <Text style={[modalStyles.headerText, styles.headerLandingText]}>Piclo</Text>
      <View style={styles.imageContainer}>
        <Pressable
          onPress={onWhyPiclo}
          style={({ hovered }) => [
            hovered && Platform.OS === 'web' && { transform: [{ scale: 1.05 }] } as any
          ]}
        >
          <Image style={styles.landingImage} source={require('../../../assets/images/landing-1.png')} />
        </Pressable>
      </View>
      <Text style={styles.messageText}>
        Find colors from your surroundings to reveal today's Piclo!{'\n\n'}
        📸 <Text style={styles.noteText}>Camera access required for gameplay.{'\n'}Data will not be stored or transmitted.</Text>
      </Text>

      <View style={styles.listGroup}>
        {/* <MenuListItem
          icon={<FontAwesome6 name="palette" size={18} color={colors.text} solid/>}
          label="Browse Piclo Packs"
          onPress={onBrowsePacks}
        />

        <MenuListItem
          icon={<FontAwesome6 name="paintbrush" size={18} color={colors.text} solid/>}
          label="Create a Custom Piclo"
          onPress={onCreateCustom}
        /> */}

        <MenuListItem
          icon={<FontAwesome6 name={isMuted ? "volume-xmark" : "volume-high"} size={18} color={colors.text} solid />}
          label={isMuted ? "Unmute Audio" : "Mute Audio"}
          onPress={onToggleMute}
          isCentered
          noChevron
          isLast
        />
      </View>

    </BaseModal>
  );
}

const styles = StyleSheet.create({
  imageContainer: {
    alignItems: 'center',
    marginBottom: 30,
  },
  circlePlaceholder: {
    width: 100,
    height: 100,
    borderRadius: 50,
    backgroundColor: colors.background,
    borderWidth: 2,
    borderColor: colors.border,
  },
  landingImage: {
    width: 175,
    height: 175,
    borderRadius: 100,
  },
  listGroup: {
    width: '100%',
    marginBottom: 16,
  },
  footerPrimaryButton: {
    marginBottom: 8,
  },
  headerLandingText: {
    fontFamily: 'FrederickaTheGreat_400Regular',
    fontSize: 45,
    lineHeight: 52,
  },
  messageText: {
    ...typography.body,
    color: colors.text,
    textAlign: 'center',
    marginBottom: 20,
  },
  noteText: {
    ...typography.body,
    fontSize: 16,
    color: colors.textMuted,
    fontStyle: 'italic',
  },
});
